<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chtitled" id="Maps"><span epub:type="pagebreak" id="pagexviii" title="xviii"><span class="bold">Maps</span></span></h2>
<div class="image">
<img alt="image" src="images/pagevl1_xviii-1.jpg"/>
<div class="figcapbox">
<p class="fcaption" id="figurexviii-1">Indochina. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)</p>
</div>
</div>
<div class="image">
<img alt="image" src="images/pagevl1_xix-1.jpg"/>
<div class="figcapbox">
<p class="fcaption" id="figurexix-1"><span epub:type="pagebreak" id="pagexix" title="xix">North Vietnam. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)</span></p>
</div>
</div>
<div class="image">
<img alt="image" src="images/pagevl1_xx-1.jpg"/>
<div class="figcapbox">
<p class="fcaption" id="figurexx-1"><span epub:type="pagebreak" id="pagexx" title="xx">South Vietnam. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)</span></p>
</div>
</div>
<div class="image">
<img alt="image" src="images/pagevl1_xxi-1.jpg"/>
<div class="figcapbox">
<p class="fcaption" id="figurexxi-1"><span epub:type="pagebreak" id="pagexxi" title="xxi">Area of Operations 1st Infantry Division. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)<span epub:type="pagebreak" id="pagexxii" title="xxii"></span></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Maps.vue?55beebbe